/**************************************************************| CONVERT VARIANT TO SWATCHES |*/
$(function() {
	if($(".single-option-selector").length) {

		$(".single-option-selector").each(function(i) {
			var $thisSelect = $(this);
			var $newClass = "js-option-selector-" + i;
			var $newOptions = '<ul class="new-variant-swatchs">';
			var $currentOption = $thisSelect.val();

			$thisSelect.find("option").each(function() {
				var $this = $(this);
				var $optionText = $this.text();
				var $optionVal = $this.val();
				var $soldOut = $this.hasClass("is-soldout");

				$newOptions += '<li class="new-variant-swatch js-new-variant-swatch' +
					($currentOption == $optionVal ? ' is-active' : '') +
					($soldOut ? ' is-soldout' : '') + '" data-val="' + $optionVal + '" data-select="' + $newClass + '">' +
					$optionText +
					'</li>';
			});

			$thisSelect.addClass("is-hidden").addClass($newClass).after($newOptions + '</ul>');
		});


		$(document).on("click", ".js-new-variant-swatch", function() {

			if(!$(this).hasClass("is-soldout")) {
				var $this = $(this);
				var $select = $this.attr("data-select");
				var $val = $this.attr("data-val");
				var $parent = $this.parent("ul");

				$('.' + $select).val($val).trigger("change");
				$parent.children("li").removeClass("is-active");
				$(this).addClass("is-active");

			}
		});
	}
});